import { Button, Flex, Icon, Text } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { FaPlus } from 'react-icons/fa';

type EmptyStateProps = {
	/** Icon shown inside the crest badge. Falls back to the Windfall "W" monogram. */
	icon?: IconType;
	title: string;
	description?: string;
	/** When both actionLabel and onAction are set, a primary call-to-action button is rendered. */
	actionLabel?: string;
	onAction?: () => void;
};

/**
 * Shared empty state: a crest badge, a title, an optional line of guidance and
 * an optional primary action. Turns a blank list into an invitation to act.
 */
export const EmptyState = ({ icon, title, description, actionLabel, onAction }: EmptyStateProps) => {
	return (
		<Flex
			flexDir="column"
			align="center"
			justify="center"
			textAlign="center"
			gap="10px"
			width="100%"
			py="70px"
			px="20px"
		>
			<Flex
				align="center"
				justify="center"
				boxSize="66px"
				borderRadius="18px"
				mb="6px"
				bgGradient="linear(160deg, blue.700, blue.900)"
				boxShadow="md"
			>
				{icon ? (
					<Icon as={icon} boxSize="26px" color="brass.400" />
				) : (
					<Text fontFamily="heading" fontWeight="800" fontSize="28px" color="brass.400">
						W
					</Text>
				)}
			</Flex>
			<Text fontSize="18px" fontWeight="bold" color="ink">
				{title}
			</Text>
			{description && (
				<Text fontSize="14px" color="gray.500" maxW="42ch">
					{description}
				</Text>
			)}
			{actionLabel && onAction && (
				<Button mt="8px" leftIcon={<FaPlus />} colorScheme="blue" onClick={onAction}>
					{actionLabel}
				</Button>
			)}
		</Flex>
	);
};
